import docReady from '../../common/docReady';
import passwordValidation from '../../common/lib/passwordValidation';

docReady(() => {
  passwordValidation();
  // Handle referral code
  const referralField = document.querySelector('[data-referral]') as HTMLInputElement;
  if (referralField && (window as any).promotekit_referral) {
    referralField.value = (window as any).promotekit_referral;
  }
});
